import { render, staticRenderFns } from "./serPackageManagement.vue?vue&type=template&id=3aa8d5f2&"
import script from "./serPackageManagement.vue?vue&type=script&lang=js&"
export * from "./serPackageManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports